

window.pizza = {};

jQuery(function ($) {
  window.pizza.allPizza = function() {
    $('.pizza-image, #instagram').removeClass('d-none');
    $('#allPizza').remove();
  }
  
}); 